// extracted by mini-css-extract-plugin
module.exports = {"logo":"siteLogo_logo__YsZYA"};